import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardBody } from '@structural-climbing/ui'

interface Props {
  /** The question the card answers, as its title. */
  question: string
  aside?: ReactNode
  children: ReactNode
  /** What the number means, in a sentence. */
  answers: string
  /** Where the number comes from. */
  source: string
  className?: string
}

/** A Statistics card: a question, its number and chart, and where it comes from. */
export function QuestionCard({
  question,
  aside,
  children,
  answers,
  source,
  className = '',
}: Props) {
  const { t } = useTranslation()
  return (
    <Card shadow="sm" className={className}>
      <CardBody className="flex flex-col gap-3 px-4 py-4">
        <div className="flex items-baseline justify-between gap-2">
          <h2 className="text-[15px] font-semibold">{question}</h2>
          {aside && <span className="shrink-0 text-xs text-foreground/55">{aside}</span>}
        </div>
        {children}
        <p className="mt-auto border-t border-divider pt-2 text-xs leading-relaxed text-foreground/55">
          <span className="font-semibold text-foreground/80">
            {t('statistics.insights.answersLabel')}
          </span>{' '}
          {answers}
          <br />
          <span className="font-semibold text-foreground/80">
            {t('statistics.insights.sourceLabel')}
          </span>{' '}
          {source}
        </p>
      </CardBody>
    </Card>
  )
}
